import { ApiError, humanizeApiError } from '@discovr/common';
import {
  HTTP_ERROR_STATUSES,
  STATUS_ERROR,
  UNKNOWN_ERROR,
  type HttpErrorStatus,
} from './constants/discoveryCopy';

const isHttpErrorStatus = (status: number): status is HttpErrorStatus =>
  HTTP_ERROR_STATUSES.some((known) => known === status);

export function errorText(error: unknown): string {
  if (error instanceof ApiError) {
    return isHttpErrorStatus(error.httpStatus)
      ? STATUS_ERROR[error.httpStatus]
      : humanizeApiError(error);
  }
  return error instanceof Error && error.message ? error.message : UNKNOWN_ERROR;
}
